import { render, staticRenderFns } from "./TrimmingProfilePage.vue?vue&type=template&id=1572e095&"
import script from "./TrimmingProfilePage.vue?vue&type=script&lang=js&"
export * from "./TrimmingProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports